import React from 'react';

/**
 * keep-alive 프로그램 페이지가 연간진도 등(공유 searchParams)으로 숨겨질 때
 * URL에서 `programTerm`이 사라져 term=null → 표가 통째로 내려가는 것을 막는다.
 */
export function useKeepAliveProgramTerm(
  isActive: boolean,
  programTermFromUrl: string | null
): 1 | 2 | null {
  const lastActiveTermRef = React.useRef<1 | 2 | null>(null);
  return React.useMemo(() => {
    const fromUrl =
      programTermFromUrl === '1' || programTermFromUrl === '2'
        ? (Number(programTermFromUrl) as 1 | 2)
        : null;
    if (!isActive) return lastActiveTermRef.current ?? fromUrl;
    if (fromUrl != null) lastActiveTermRef.current = fromUrl;
    return fromUrl ?? lastActiveTermRef.current;
  }, [isActive, programTermFromUrl]);
}
